document.querySelectorAll('.open-option').forEach(button => {
  button.addEventListener('click', function(event) {
    const cardWrapper = button.closest('.card-wrapper');
    const quickView = cardWrapper.querySelector('.quick-view');
    document.querySelectorAll('.quick-view').forEach(view => {
      view.style.display = 'none';
    });
    quickView.style.display = 'block';
    event.stopPropagation();
    document.addEventListener('click', function handleClickOutside(event) {
      if (!quickView.contains(event.target) && !button.contains(event.target)) {
        quickView.style.display = 'none';
        document.removeEventListener('click', handleClickOutside);
      }
    });
  });
});

document.querySelectorAll('.subscribe-radio, .purchase-radio').forEach(radio => {
  radio.addEventListener('change', function() {
    const cardWrapper = radio.closest('.card-wrapper');
    if (cardWrapper) {
      const form = cardWrapper.querySelector('form');
      if (form) {
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = radio.value;
          const sellingPlanId = radio.getAttribute('data-selling-plan');
          // Hide the quick-view
          const quickView = cardWrapper.querySelector('.quick-view');
          if (quickView) {
            setTimeout(() => {
            quickView.style.display = 'none';
            }, 1500);
          }
          // Submit the form with Ajax
          submitFormWithAjax(form, sellingPlanId);
          // Uncheck the radio buttons after a delay
          setTimeout(() => {
            document.querySelectorAll('.subscribe-radio, .purchase-radio').forEach(r => {
              r.checked = false;
            });
          }, 3000);
        } else {
          console.error('Variant ID input not found in the form.');
        }
      } else {
        console.error('Form not found in the card wrapper.');
      }
    } else {
      console.error('Card wrapper not found for the radio button.');
    }
  });
});

document.querySelectorAll('.button[name="selling_plan"]').forEach(button => {
  button.addEventListener('click', function(event) {
    const cardWrapper = button.closest('.card-wrapper');
    if (cardWrapper) {
      const form = cardWrapper.querySelector('form');
      if (form) {
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = button.value;
          const sellingPlanId = button.getAttribute('data-selling-plan');
          const loader = button.querySelector('.loading-overlay__spinner');
          // Show the loader and hide the text
          if (loader) {
            loader.classList.remove('hidden');
            button.childNodes[0].textContent = ''; // Hide the text
          }
          // Hide the quick-view
          const quickView = cardWrapper.querySelector('.quick-view');
          if (quickView) {
            quickView.style.display = 'none';
          }
          // Submit the form with Ajax
          submitFormWithAjax(form, sellingPlanId);
          // Hide the loader and show the text again after 1000ms
          setTimeout(() => {
            if (loader) {
              loader.classList.add('hidden');
              button.childNodes[0].textContent = 'Subscribe'; // Show the text again
            }
          }, 1000);
        } else {
          console.error('Variant ID input not found in the form.');
        }
      } else {
        console.error('Form not found in the card wrapper.');
      }
    } else {
      console.error('Card wrapper not found for the button.');
    }
  });
});

function submitFormWithAjax(form, sellingPlanId = null) {
  const variantId = form.querySelector('input[name="id"]').value;
  const items = [{
    id: variantId,
    quantity: 1,
    selling_plan: sellingPlanId ? sellingPlanId : null,
  }];

  const sectionsToRender = [
    'cart-drawer',
    'cart-icon-bubble',
  ];

  const body = JSON.stringify({
    items,
    sections: sectionsToRender.join(','),
    sections_url: window.location.pathname,
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: body,
  })
  .then(response => response.json())
  .then(data => {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const emptyCart = document.querySelector('.drawer').classList.contains('is-empty');
    if (cart && cart.renderContents) {
      if (emptyCart) {
        document.querySelector('.drawer').classList.remove('is-empty');
      }
      cart.renderContents(data);
    } else {
      console.error('Cart element not found or does not have a renderContents method.');
    }
    document.dispatchEvent(new CustomEvent('openCartDrawer'));
  })
  .catch(error => {
    console.error('Error submitting form:', error);
  });
}
